import Swiper from 'swiper/swiper-bundle';

export function stages() {
  const CLASS_SWIPER = 'swiper';
  const CLASS_WRAPPER = 'swiper-wrapper';
  const CLASS_SLIDE = 'swiper-slide';
  const MOBILE_BREAKPOINT = 768;
  const stagesItems = document.querySelectorAll(".stages-item__counter");
  const swiperContainer = document.querySelector(`.section-stages__content.${CLASS_SWIPER}`);
  const swiperWrapper = swiperContainer.querySelector(`.${CLASS_WRAPPER}`);
  const swiperElements = swiperContainer.querySelectorAll(`.${CLASS_SLIDE}`);
  let mySwiper = null;
  let minResize = false;
  let maxResize = false;

  if (!stagesItems.length || !swiperContainer) {
    return;
  }

  function handleScroll() {
    const scrollPos = window.scrollY;
    const windowHeight = window.innerHeight;

    stagesItems.forEach((counter) => {
      const itemRect = counter.getBoundingClientRect();
      const itemOffset = itemRect.top + scrollPos;
      const itemHeight = itemRect.height;
      const itemMiddle = itemOffset + itemHeight / 2;

      if (itemMiddle < scrollPos + windowHeight / 2) {
        counter.classList.add('active');
      } else {
        counter.classList.remove('active');
      }
    });
  }

  function initSlider() {
    setOrRemoveClasses('add');

    function updatePaginationStyles() {
      const buttons = document.querySelectorAll('.custom-pagination .custom-pagination__button');
      const activeIndex = mySwiper.activeIndex;

      buttons.forEach(function (button, index) {
        button.classList.toggle('custom-pagination__button-active', index <= activeIndex);
      });
    }

    mySwiper = new Swiper(swiperContainer, {
      spaceBetween: 16,
      slidesPerView: 1,
      pagination: {
        el: '.custom-pagination',
        clickable: true,
        bulletClass: 'custom-pagination__button title',
        bulletActiveClass: 'custom-pagination__button-active',
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        },
      },
      on: {
        slideChange: function () {
          updatePaginationStyles();
        },
      },
    });
  }

  function destroySlider() {
    setOrRemoveClasses('remove');

    if (mySwiper) {
      mySwiper.destroy();
      mySwiper = null;
    }
  }

  function setOrRemoveClasses(type) {
    swiperContainer.classList[type](CLASS_SWIPER);
    swiperWrapper.classList[type](CLASS_WRAPPER);

    swiperElements.forEach(slideElement => {
      slideElement.classList[type](CLASS_SLIDE);
    });
  }

  function handleScreenSizeChange() {
    const windowWidth = window.innerWidth;

    if (windowWidth >= MOBILE_BREAKPOINT && !maxResize) {
      maxResize = true;
      minResize = false;

      destroySlider();

      window.addEventListener('scroll', handleScroll);
      handleScroll();
    }

    if (windowWidth < MOBILE_BREAKPOINT && !minResize) {
      minResize = true;
      maxResize = false;

      initSlider();

      window.removeEventListener('scroll', handleScroll);
    }
  }

  window.addEventListener('resize', handleScreenSizeChange);
  handleScreenSizeChange();
}


// WEBPACK FOOTER //
// app/scripts/components/stages.js